import { Box, CircularProgress } from '@mui/material'

export function FullPageSpinner() {
  return (
    <Box role="status" aria-label="Loading" sx={{ height: '100%', display: 'grid', placeItems: 'center' }}>
      <CircularProgress />
    </Box>
  )
}
